//
// Base resource for retrieve data
//
// const baseUrl = "http://192.168.0.2:5000/api";

// const baseUrl = "https://testserver.fujisushi.no/api";
// const baseUrl = "https://etakeawaystage.azurewebsites.net/api";
const baseUrl = "https://server.fujisushi.no/api";

const paymentUrl = `${baseUrl}/bamborapayment/CreatePaymentSessionWithAnonymousOrder`;

const netsPaymentUrl = `${baseUrl}/netspayment`;

const paymentTestUrl = `${baseUrl}/bamborapayment/CreatePaymentSessionTest`;

const paymentAcceptUrl = `${baseUrl}/bamborapayment/handlecheckoutaccept`;

const paymentCancelUrl = `${baseUrl}/bamborapayment/handlecheckoutcancel`;

const netsPaymentAcceptUrl = `${baseUrl}/netspayment/handlenetscheckoutaccept`;

const netsPaymentCancelUrl = `${baseUrl}/netspayment/handlenetscheckoutcancel`;

const pickupNumberUrl = `${baseUrl}/pickupnumbers`;

const restaurantsUrl = `${baseUrl}/restaurants`;

const menusUrl = `${baseUrl}/menus`;

const ordersUrl = `${baseUrl}/orders`;

const openingtimesUrl = `${baseUrl}/openingtimetables`;

const waitingtimesUrl = `${baseUrl}/waitingtimes`;

const ordermanagerUrl = `${baseUrl}/ordermanagement`;

export {
  baseUrl,
  paymentUrl,
  paymentAcceptUrl,
  paymentCancelUrl,
  pickupNumberUrl,
  restaurantsUrl,
  menusUrl,
  ordersUrl,
  openingtimesUrl,
  waitingtimesUrl,
  ordermanagerUrl,
  paymentTestUrl,
  netsPaymentUrl,
  netsPaymentAcceptUrl,
  netsPaymentCancelUrl

};
